import ReactDatePicker from 'react-datepicker'
import { Dispatch, SetStateAction } from 'react'
import { parseISO } from 'date-fns'
import dayjs from 'dayjs'

import 'react-datepicker/dist/react-datepicker.css'
import Icon from '../Icon'

import './style.css'

interface DatePickerProps {
	sessionsDates: Array<{
		day: string
		hours: string[]
	}>
	selectedDate?: string
	className?: string
	setSelectedDate?: Dispatch<SetStateAction<string | undefined>>
}

const months = [
	'Janeiro',
	'Fevereiro',
	'Março',
	'Abril',
	'Maio',
	'Junho',
	'Julho',
	'Agosto',
	'Setembro',
	'Outubro',
	'Novembro',
	'Dezembro',
]

export default function DatePicker({
	sessionsDates,
	selectedDate,
	setSelectedDate,
}: DatePickerProps) {
	const dateFormatted = selectedDate ? new Date(parseISO(selectedDate)) : null

	return (
		<ReactDatePicker
			selected={dateFormatted || null}
			onChange={(date: Date) => {
				setSelectedDate &&
					setSelectedDate(dayjs(date).locale('pt-br').format('YYYY-MM-DD'))
			}}
			inline
			minDate={
				sessionsDates &&
				new Date(
					dayjs(sessionsDates[0].day)
						.locale('pt-br')
						.format('YYYY-MM-DD HH:mm:ss')
				)
			}
			maxDate={
				sessionsDates &&
				new Date(
					dayjs(sessionsDates[sessionsDates.length - 1].day)
						.locale('pt-br')
						.format('YYYY-MM-DD HH:mm:ss')
				)
			}
			includeDates={
				sessionsDates &&
				sessionsDates.map(
					({ day }) =>
						new Date(dayjs(day).locale('pt-br').format('YYYY-MM-DD HH:mm:ss'))
				)
			}
			renderCustomHeader={({
				date,
				prevMonthButtonDisabled,
				nextMonthButtonDisabled,
				decreaseMonth,
				increaseMonth,
			}) => {
				const month = date.getMonth()

				const dateText = `${months[month]} ${date.getFullYear()}`

				return (
					<div className='react-datepicker__current-month'>
						<span>{dateText}</span>

						<div className='react-datepicker__nav'>
							<button
								type='button'
								onClick={decreaseMonth}
								disabled={prevMonthButtonDisabled}
							>
								<Icon name='new-arrow-left' width='16px' height='16px' />
							</button>

							<button
								type='button'
								onClick={increaseMonth}
								disabled={nextMonthButtonDisabled}
							>
								<Icon name='new-arrow-right' width='16px' height='16px' />
							</button>
						</div>
					</div>
				)
			}}
		/>
	)
}
